<script>
    import { fa0, faBriefcase, faBullhorn, faCog, faCogs, faGift, faGifts, faHouse, faMobilePhone, faMobileScreen, faPhone, faPoo, faStamp, faTicket, faTicketAlt, faUnlockKeyhole } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";
    import { link } from "svelte-routing";
    import { admin } from "../../../firebase/auth";
    import { menu } from "../../../stores";
    import AccountWidget from "../../navbar/AccountWidget.svelte";
    import AccountWidgetFull from "./AccountWidgetFull.svelte";
    import Item from "./Item.svelte";
    import Menu from "./Menu.svelte";
    import MenuGroup from "./MenuGroup.svelte";
    import MenuItem from "./MenuItem.svelte";
</script>


<div class="navbar-container" class:active={$menu}>
    <div class="header">
        <img src="/resources/logo.svg" alt="" height="40">
    </div>
    <div class="center">
        <Menu>
            <MenuItem to={"/profil"}>
                <Fa icon={faHouse} slot="icon"/>
                Betriebsprofil
            </MenuItem>
            <MenuGroup>
                <Fa icon={faStamp} slot="icon"/>
                <span slot="title">Stempeln</span>
                <!-- <Item href="/stempel-legacy">Stempel (veraltet)</Item> -->
                <Item href="/stempel">Stempel</Item>
                <Item href="/stempelkarten">Stempelkarten</Item>
                <!-- <Item href="/losaktionen">Losaktionen</Item> -->
                <Item href="/geraete">Geräte</Item>
            </MenuGroup>
            <MenuItem to={"/angebote"}>
                <Fa icon={faBullhorn} slot="icon"/>
                Angebote
            </MenuItem>

            <!-- <MenuGroup>
                <Fa icon={faBriefcase} slot="icon"/>
                <span slot="title">Subscription</span>
                <Item href="/subscriptions">Verwalten</Item>
                <Item href="/subscriptions/rechnungen">Rechnungen</Item>
            </MenuGroup>
            <MenuItem to={"/verwalten"}>
                <Fa icon={faCog} slot="icon"/>
                Verwalten
            </MenuItem> -->
        </Menu>
    </div>
    <div class="footer">
        <AccountWidgetFull />
    </div>
</div>

<style>
    @media only screen and (max-width: 600px) {
        .navbar-container {
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            height: 100%;
            transform: translateX(-100%);
            transition: transform 200ms ease-in-out;
        }
        
        .navbar-container.active {
            transform: translateX(0);
        }
    }

    .navbar-container {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 300px;
        z-index: 1;
        background-color: #F5F2EF;
        width: 300px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    
    .header  {
        height: 40px;
        padding: 2rem;
        /* text-align: center; */
    }

    .center {
        padding: 0 1rem;
        flex: 1;
        align-content: center;
    }

    .footer {
        padding: 1rem;
    }
</style>